import React from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Loading from '../../loading';
import { Grid, Card, Dropdown, Table, Button, Icon } from 'semantic-ui-react';
import Add from './add';
import AddPart from './AddPart';

class PriceMenu extends React.Component {

state = {
  load: false, message: '', customertype: null,  DiscountParts: [],
  DiscountLevel: [], customer: '', menuPermission: [], NoDiscountParts: []
}

componentDidMount() {
  this.menuControl();
}

menuControl() {
  let menuPermission = Permission('discount-menu', this.props.menus);
  if (menuPermission.view) {
    this.getDiscountLevel();
  }
  this.setState({ menuPermission })
}

getDiscountLevel() {
  let context = this;
  context.setState({ load: false, message: 'Getting Discount Level!!!' })
  $.ajax({
    type: 'POST', url: Server() + 'WebMaster/DiscountMenu/GetDiscountLevelName.php',
    success: function(data) {
      try {
        data = JSON.parse(data);
        let DiscountLevelOption = [];
        data.map((c) => {
          DiscountLevelOption.push({ key: c.name, text: c.name, value: c.id })
        })
        context.setState({ DiscountLevel: data, DiscountLevelOption, load: false });
      } catch (e) {
        context.setState({ load: false, DiscountLevel: [] });
      }
    },
    error: function(e) {
      alert('Try again!!')
      context.setState({ load: false });
    }
  });
}


GetDiscountParts = () => {
  let context = this;
  if (!this.state.SelectedDiscountLevel) {
    alert('Select Price Level!!!');
    return;
  }
  context.setState({ load: true, message: 'Getting Discount Level!!!' })
  $.ajax({
    type: 'POST', data: { 'mid': this.state.SelectedDiscountLevel }, 
    url: Server() + 'WebMaster/DiscountMenu/GetDiscountParts.php',
    success: function(data) {
      console.log(data);
      try {
        data = JSON.parse(data);
        let DiscountParts = [];
        let NoDiscountParts = [];
        data.map((c) => {
          if (c.discount) {
            DiscountParts.push(c)
          }
          else {
            NoDiscountParts.push(c)
          }
        })
        DiscountParts = DiscountParts.filter((v,i,a)=>a.findIndex(t=>(t.partno === v.partno && t.brand_name === v.brand_name))===i)
        context.setState({ DiscountParts, NoDiscountParts, load: false });
      } catch (e) {
        context.setState({ load: false, DiscountParts: [] });
      }
    },
    error: function(e) {
      alert('Try again!!')
      context.setState({ load: false });
    }
  });
}

changeDiscountLevel = (f, { value }) => {
  this.setState({ SelectedDiscountLevel: value });
}

delete = (item) => {
  let context = this;
  $.ajax({
    type: 'POST', data: { 'id': item.discount_id }, 
    url: Server() + 'WebMaster/DiscountMenu/deletepart.php',
    success: function(data) {
        if (data == 1) {
          context.GetDiscountParts();
        }
        else {
          alert('Error')
        }
    },
    error: function(e) {
      alert('Try again!!')
      context.setState({ load: false });
    }
  });
  
}

convertIntoNumber = (value) => {
  try {
      value = Number(value);
  } catch (error) {
      value = 0;
  }
  return value;
}

makeDecimalPoints = (value) => {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
}


render() {
  let { DiscountLevel, DiscountParts, NoDiscountParts } = this.state;
  let i = 1;
  return (
    <div>
      <Title title={'Discount Menu'} openDrawer={this.props.openDrawer} />
      { this.state.menuPermission.view ?
        (
          <div style={{margin: '1%'}}>
            <Loading load={this.state.load} message={this.state.message} />
            <div style={{display: 'flex'}}>
              <div>
                Selected Discount Level<br/>
                <Dropdown placeholder='Selected Discount Level' style={{ borderColor: '#5A9CBB', width: '300px' }}
                  fluid search selection onChange={this.changeDiscountLevel}
                  options={this.state.DiscountLevelOption} value={this.state.SelectedDiscountLevel} />
              </div>
              <div style={{marginLeft: '0.5%'}}>
                <br/><Button onClick={this.GetDiscountParts}>Submit</Button>
              </div>
              <div style={{marginLeft: '0.5%'}}>
                <br/><Add DiscountLevel={DiscountLevel} refresh={this.getDiscountLevel} refreshSpares={this.GetDiscountParts} />
              </div>
              <div style={{marginLeft: '0.5%'}}>
                <br/><AddPart NoDiscountParts={NoDiscountParts} refresh={this.GetDiscountParts}  mid={this.state.SelectedDiscountLevel} />
              </div>
            </div>
            <table width='100%' id='emp_table'>
              <tr id='tableheader'>
                <th id='tablecolumn'><b>S.No</b></th>
                <th id='tablecolumn'><b>Partno</b></th>
                <th id='tablecolumn'><b>Spare Name</b></th>
                <th id='tablecolumn'><b>Brand</b></th>
                <th id='tablecolumn'><b>DNP</b></th>
                <th id='tablecolumn'><b>MRP</b></th>
                <th id='tablecolumn'><b>Discount</b></th>
                <th id='tablecolumn'><b>Discount Rs</b></th>
                <th id='tablecolumn'><b>Price</b></th>
                <th id='tablecolumn'><b>Action</b></th>
              </tr>
              {
                DiscountParts.map((c) => {
                  console.log(c);
                  let mrp = this.convertIntoNumber(c.mrp);
                  let discount = this.convertIntoNumber(c.discount);
                  let discountrs = (mrp * discount)/100;
                  return (
                    <tr>
                      <td>{i++}</td>
                      <td>{c.partno}</td>
                      <td>{c.spare_name}</td>
                      <td>{c.brand_name}</td>
                      <td>{c.dnp}</td>
                      <td>{c.mrp}</td>
                      <td>{c.discount}</td>
                      <td>{discountrs}</td>
                      <td>{mrp - discountrs}</td>
                      <td onClick={ () => this.delete(c)}><center>Delete</center></td>
                    </tr>
                  )
                })
              }
            </table>
          </div>
        ):
        (
          <div>
            <center>You are not allow to access this menu!!!</center>
          </div>
        )
      }
    </div>
  );
}
}

export default PriceMenu;
